import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import { NumericFormat } from "react-number-format";

const FormAddPayment = () => {
  const [amount, setAmount] = useState(0);
  const [contract_no, setContractNo] = useState("");
  const [due_amount, setDueAmount] = useState("");
  const [payment_method, setPaymentMethod] = useState("");
  const [last_time_paid, setTimePaid] = useState("");
  const [note, setNote] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const getContractById = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/contracts/${id}`, {
          headers: {
              'X-API-Key': API_KEY
          },
        });
        setContractNo(response.data.contract_no);
        setDueAmount(response.data.due_amount);
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getContractById();
  }, [id]);

  const handleAmountChange = (values) => {
    const { floatValue } = values;
    setAmount(floatValue); 
  };

  const handleDueAmountChange = (values) => {
    const { floatValue } = values;
    setDueAmount(floatValue); 
  };

  const handleTimePaidChange = (event) => {
      setTimePaid(event.target.value);
    };

  const updateContract = async (e) => {
    if(amount > due_amount){
      alert("Over-Payment, Payment Amount greater than Due Amount, please check again!");
    }else{
      if (window.confirm('Are you sure you want to proccess this payment?')) {
        e.preventDefault();
        try {
          await axios.patch(`${API_BASE_URL}/contracts/${id}`, {
            headers: {
              'X-API-Key': API_KEY
            },
            contract_no: contract_no,
            due_amount: due_amount,
            amount: amount,
            payment_method: payment_method,
            note: note,
            last_time_paid: last_time_paid,
          });
          navigate("/contracts");
        } catch (error) {
          if (error.response) {
            setMsg(error.response.data.msg);
          }
        }
      }else{
        return
      }
    }
  };
  return (
    <div className="container">
      <h1 className="title is-size-5">Add Contract Payment</h1>
      <div className="card is-shadowless">
        <form onSubmit={updateContract}>
          <p className="has-text-centered">{msg}</p>
          <div className="field columns">
            <div className="column is-4">
                <label className="label">Contract_No</label>
                <div className="control">
                    <input
                        type="text"
                        className="input"
                        value={contract_no}
                        onChange={(e) => setContractNo(e.target.value)}
                        disabled
                    />
                </div>
            </div>
            
            <div className="column is-4">
                <label className="label">Due_Amount</label>
                <div className="control">
                    <NumericFormat
                        id="due_amount-input"
                        className="input"
                        value={due_amount}
                        onValueChange={handleDueAmountChange}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        valueIsNumericString={true} 
                        disabled
                    />
                </div>
            </div>
          </div>
          <div className="field columns">
            <div className="column is-4">
                <label className="label">Payment Amount</label>
                <div className="control">
                    <NumericFormat
                        id="amount-input"
                        className="input"
                        value={amount}
                        onValueChange={handleAmountChange}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        allowNegative={false}
                        valueIsNumericString={true} 
                        placeholder="Payment Amount"
                    />
                </div>
            </div>
            <div className="column is-4">
                <label className="label">Payment Method</label>
                <div className="select is-fullwidth">
                    <select
                      value={payment_method}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      required
                    >
                      <option value="">Select Payment Method</option>
                      <option value="Cash">Cash</option>
                      <option value="Transfer">Transfer</option>
                    </select>
                  </div>
            </div>
            <div className="column is-4">
                <label className="label">Time_Paid</label>
                <div className="control">
                    <div className="is-fullwidth">
                        <input className="input"
                            type="datetime-local"
                            id="time_paid"
                            name="time_paid"
                            value={last_time_paid} // Controlled component
                            onChange={handleTimePaidChange}
                            required
                        />
                    </div>
                </div>
            </div>
          </div>  
          <div className="field">
            <label className="label">Note</label>
            <div className="control">
                <textarea
                    className="textarea"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Note"
                    rows="3"
                ></textarea>
            </div>
          </div>            
          <div className="field">
            <div className="control">
              <Link to="/contracts">
              <button className="button is-small is-warning mr-1">
                Cancel
              </button>
              </Link>
              <button type="submit" className="button is-small is-success">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormAddPayment;
